// extracted by mini-css-extract-plugin
export default {"address1":"display_address1__o+-bu"};